import Line from './Line';
import Circle from './Circle';
export { Line, Circle };
export default {
  Line: Line,
  Circle: Circle
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-progress/es/index.js
// module id = 1392
// module chunks = 0